import React, { useEffect, useRef } from "react";
import { Dialog, Typography, Box, IconButton, Avatar } from "@material-ui/core";
import VideoCallIcon from "@material-ui/icons/VideoCall";
import CallIcon from "@material-ui/icons/Call";
import CallEndIcon from "@material-ui/icons/CallEnd";
import { useCall } from "../../../context/CallContext";

// Utility function to convert a string to title case
const toTitleCase = (str) => {
  if (!str) return "";
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
};

const IncomingVideoCallModal = ({ caller, callType }) => {
  const audioRef = useRef(null);

  // CORRECTED: Get the functions directly from the context
  const { acceptCall, rejectCall } = useCall();

  // Destructure caller and ensure it exists
  if (!caller) return null;

  const { senderName, avatarUrl } = caller;

  useEffect(() => {
    // Only play audio if the modal is actively open
    if (caller) {
      const audio = new Audio("/sounds/video-ringtone.mp3");
      audio.loop = true;
      audio.play().catch((err) => {
        console.warn("Autoplay failed:", err);
      });
      audioRef.current = audio;
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current = null;
      }
    };
  }, [caller]);

  const modalTitle =
    callType === "video" ? "Incoming Video Call" : "Incoming Voice Call";

  // CORRECTED: Define the handlers here
  const handleAcceptClick = () => {
    acceptCall();
  };

  const handleRejectClick = () => {
    rejectCall(caller?.fromUserId);
  };

  return (
    <Dialog
      open={!!caller} // Correctly check if the caller object exists
      maxWidth={false}
      PaperProps={{
        style: {
          background: "transparent",
          boxShadow: "none",
          overflow: "visible",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      }}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 1)",
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        bgcolor="rgba(0, 0, 0, 0.5)"
        borderRadius={8}
        p={4}
        width={320}
        height={520}
        justifyContent="center"
      >
        <Box mb={2} display="flex" flexDirection="column" alignItems="center">
          {callType === "video" ? (
            <VideoCallIcon style={{ color: "white" }} />
          ) : (
            <CallIcon style={{ color: "white" }} />
          )}
          <Typography variant="h5" style={{ color: "white" }}>
            {toTitleCase(modalTitle)}
          </Typography>
        </Box>
        <Avatar
          src={avatarUrl}
          alt={senderName}
          style={{
            width: 200,
            height: 200,
            marginBottom: "16px",
            border: "2px solid #ccc",
          }}
        />

        <Typography
          gutterBottom
          style={{ color: "white", fontWeight: "bold", fontSize: "1.5rem" }}
        >
          {toTitleCase(senderName)}
        </Typography>

        <Typography variant="body1" style={{ color: "white" }}>
          is calling you...
        </Typography>

        <Box
          display="flex"
          justifyContent="center"
          style={{ gap: 30, marginTop: 32 }}
        >
          <IconButton
            // CORRECTED: Call the local handler
            onClick={handleRejectClick}
            style={{
              backgroundColor: "white",
              color: "red",
              width: 60,
              height: 60,
              marginRight: 20,
            }}
          >
            <CallEndIcon fontSize="large" />
          </IconButton>

          <IconButton
            // CORRECTED: Call the local handler
            onClick={handleAcceptClick}
            style={{
              backgroundColor: "white",
              color: "green",
              width: 60,
              height: 60,
            }}
          >
            <CallIcon fontSize="large" />
          </IconButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default IncomingVideoCallModal;
